"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var grid_properties_model_1 = require("./grid-properties-model");
var row_properties_model_1 = require("./row-properties-model");
var cell_properties_model_1 = require("./cell-properties-model");
var control_properties_model_1 = require("./control-properties-model");
var immutable_1 = require("immutable");
var LayoutPropertiesModel = /** @class */ (function () {
    function LayoutPropertiesModel() {
        this.gridProperties = immutable_1.Map().asMutable();
        this.rowProperties = immutable_1.Map().asMutable();
        this.cellProperties = immutable_1.Map().asMutable();
        this.controlProperties = immutable_1.Map().asMutable();
    }
    LayoutPropertiesModel.prototype.getGridProperties = function (id) {
        return this.gridProperties.get(id, grid_properties_model_1.GridPropertiesModel.createEmpty(id));
    };
    LayoutPropertiesModel.prototype.getRowProperties = function (id) {
        return this.rowProperties.get(id, row_properties_model_1.RowPropertiesModel.createEmpty(id));
    };
    LayoutPropertiesModel.prototype.getCellProperties = function (id) {
        return this.cellProperties.get(id, cell_properties_model_1.CellPropertiesModel.createEmpty(id));
    };
    LayoutPropertiesModel.prototype.getControlProperties = function (id) {
        return this.controlProperties.get(id, control_properties_model_1.ControlPropertiesModel.createEmpty(id));
    };
    LayoutPropertiesModel.prototype.addGridProperties = function (properties) {
        this.gridProperties = this.gridProperties.set(properties.id, properties);
    };
    LayoutPropertiesModel.prototype.addRowProperties = function (properties) {
        this.rowProperties = this.rowProperties.set(properties.id, properties);
    };
    LayoutPropertiesModel.prototype.addCellProperties = function (properties) {
        this.cellProperties = this.cellProperties.set(properties.id, properties);
    };
    LayoutPropertiesModel.prototype.addControlProperties = function (properties) {
        this.controlProperties = this.controlProperties.set(properties.id, properties);
    };
    LayoutPropertiesModel.prototype.hasControlProperties = function (id) {
        return this.controlProperties.has(id);
    };
    return LayoutPropertiesModel;
}());
exports.LayoutPropertiesModel = LayoutPropertiesModel;
//# sourceMappingURL=layout-properties.model.js.map